import styles from './styles.less'

export default function SidebarFooterView({ children }) {
  return <div className={styles.footer}>{children}</div>
}
